import { createGlobalStyle } from 'styled-components';

import { BLUE_400, FONT_FAMILY, Z_INDEX_MAX } from 'styles/tokens';

const GlobalStyles = createGlobalStyle`
  body {
    font-family: ${FONT_FAMILY};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }

  /* remove scroll bounce */
  html,
  body {
    height: 100%;
    overflow: hidden;
  }

  .modal-dialog {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: ${Z_INDEX_MAX};
  }

  .modal-dialog:empty {
    display: none;
  }

  .grabbing * {
    cursor: grabbing !important;
    user-select: none;
  }

  /** Google Map overrides */
  a[href^='http://maps.google.com/maps'],
  a[href^='https://maps.google.com/maps'],
  a[href^='https://www.google.com/maps']
  {
    display: none !important;
  }

  .rich-text-link {
    color: ${BLUE_400};
    text-decoration: underline;
  }
`;

export default GlobalStyles;
